<template>
  <div>
    <!-- <stat-card class="my-2" v-if="total_count" v-model="total_count" :loading="loading">
      {{ $t('total unique user') }}
    </stat-card> -->
    <div class="pa-1">
      <v-card>
        <v-card-title>
          <v-layout>
            <v-flex>
              <template>
                {{ $t('Campaign') }}
              </template>
            </v-flex>
            <v-flex class="text-xs-right">
              <!-- <v-btn small outline color="primary">{{$t('Export')}}</v-btn> -->
            </v-flex>
          </v-layout>
        </v-card-title>

        <dashboard-graph-loading v-if="loading"></dashboard-graph-loading>

        <div style="max-width: 350px; margin: auto">
          <apexchart
            v-if="intentSeries && intentSeries.length > 0"
            :key="timestamp"
            ref="intent"
            type="pie"
            :options="intent"
            :series="intentSeries"
            style="margin: auto"
          ></apexchart>
        </div>
        <v-divider></v-divider>
        <v-data-table
          v-bind:pagination.sync="pagination"
          :headers="intentHeaders"
          :items="intentChartData"
          :rows-per-page-items="[10, 25, 45, { text: $t('All'), value: -1 }]"
          :rows-per-page-text="$t('Rows per page')"
        >
          <template v-slot:items="props">
            <td>
              <v-avatar :color="props.item.color" size="15"></v-avatar>
            </td>
            <td>
              <template v-if="props.item.name == '{default}'">{{
                $t('Default Conversation')
              }}</template>
              <template v-else-if="props.item.name == null">{{ $t('Other') }}</template>
              <template v-else-if="props.item.name == '{welcome}'">{{
                $t('Welcome Message')
              }}</template>
              <template v-else>{{ props.item.name }}</template>
            </td>
            <td>{{ props.item.value | numberFormat }}</td>
          </template>

          <template slot="no-data">
            <div class="text-xs-center">{{ $t('No conversation') }}</div>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>

<script>
import StatCard from '../analytics/StatCard'
import DashboardGraphLoading from '../analytics/DashboardGraphLoading'
import api from '@/api'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import VueApexCharts from 'vue-apexcharts'
export default {
  components: {
    DashboardGraphLoading,
    apexchart: VueApexCharts,
    StatCard
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  props: ['value', 'date', 'beaconSelect'],
  data: function() {
    return {
      total_count: 0,
      timestamp: dayjs().format('x'),
      total: 0,
      loading: true,
      intentChartData: [],
      intentHeaders: [
        { text: '', value: '', sortable: false },
        { text: this.$t('Conversation'), value: 'name' },
        { text: this.$t('Count'), value: 'value' }
        // { text: '', value: 'view', sortable: false }
      ],
      pagination: { sortBy: 'value', descending: true, rowsPerPage: 10 },

      intentSeries: [],

      intent: {
        chart: {
          type: 'donut',
          height: 350
        },
        labels: [],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                // width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }
        ],
        dataLabels: {
          enabled: true
        },
        legend: {
          show: false
        }
      },
      comment: {
        chart: {
          type: 'donut',
          height: 350
        },
        labels: [],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                // width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }
        ],
        dataLabels: {
          enabled: true
        },
        legend: {
          show: false
        }
      }
    }
  },
  mounted() {
    this.formatData()
  },
  methods: {
    async formatData() {
      var data = await api.reportMessageBeaconsList({
        pageid: this.selectedBot.pageid,
        params: {
          from_date: dayjs(this.date.start).format('YYYY-MM-DD'),
          to_date: dayjs(this.date.end).format('YYYY-MM-DD')
        }
      })
      this.total_count = data.total_count
      this.$emit('input', data.total_count)
      if (this.beaconSelect) {
        data = data.result.filter(item => item.hwid === this.beaconSelect.beacon_id)
      }
      let conversations = {
        data: [],
        label: [],
        color: [],
        intentname: [],
        intents: []
      }
      if (data && data.length > 0) {
        conversations = data
          .map(val => {
            let current_color = this.getRandomColor()
            var label = val['campaign_name']
            return {
              intent: {
                name: val['campaign_name'],
                color: current_color,
                value: parseInt(val['count'])
              },

              intentname: val['campaign_name'],
              label: label,
              count: parseInt(val['count']),
              color: current_color
            }
          })
          .reduce(
            (prev, curr) => {
              prev.data.push(curr.count)
              prev.label.push(curr.label)
              prev.intentname.push(curr.name)
              prev.color.push(curr.color)
              prev.intents.push(curr.intent)
              prev.count.push(curr.count)

              return prev
            },
            {
              data: [],
              label: [],
              intentname: [],
              color: [],
              intents: [],
              count: []
            }
          )
      }
      this.intentSeries = conversations.data
      this.intent.labels = conversations.label
      this.intent.intentname = conversations.intentname
      this.intent.colors = conversations.color

      this.intentChartData = conversations.intents

      this.$nextTick(function() {
        if (this.$refs.intent) {
          this.$refs.intent.updateOptions({
            colors: conversations.color,
            labels: conversations.label
          })
        }
        this.timestamp = dayjs().format('x')
      })
      this.loading = false
    },
    getRandomColor: function() {
      var letters = '0123456789ABCDEF'
      var color = '#'
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
      }
      return color
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/beacon/ReportMessageList.vue